import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { AppProviders } from '@/app/providers';
import { router } from '@/app/router';
import { registerStaticServiceWorker } from '@/lib/register-static-service-worker';
import { i18n } from '@/lib/i18n';
import { Skeleton } from '@/components/ui/skeleton';
import '@/styles/globals.css';

registerStaticServiceWorker();

const container = document.getElementById('root');

if (container === null) {
  throw new Error('Root element #root is missing in index.html.');
}

createRoot(container).render(
  <StrictMode>
    <AppProviders>
      <Suspense
        fallback={
          <div className="flex min-h-screen flex-col gap-4 p-6" aria-busy="true">
            <span className="sr-only">{i18n.t('common.loading')}</span>
            <Skeleton className="h-10 w-64" />
            <Skeleton className="h-64 w-full" />
          </div>
        }
      >
        <RouterProvider router={router} />
      </Suspense>
    </AppProviders>
  </StrictMode>,
);
